import React, { useEffect, useState, useMemo, useRef } from "react";
import {
  Box,
  Grid,
  Typography,
  Menu,
  Button,
  InputAdornment,
  TextField,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import cubejs from "@cubejs-client/core";
import { Table, Tooltip } from "antd";
import AutoSizer from "react-virtualized-auto-sizer";
import { FixedSizeList as List } from "react-window";

import { handleLanguageChange } from "../../utils/multiLangDashboardV2Data";
import { getMeasuresList } from "../../config/services/measures";
import { url } from "../../config/urls";
import "./style.css";
import { ReactComponent as AngleDownBlackIcon } from "../../assets/icons/icon-angle-down-black.svg";
import { ReactComponent as AngleDownIcon } from "../../assets/icons/icon-angle-down.svg";
import { ReactComponent as InputSearchIcon } from "../../assets/icons/icon-feather-search.svg";
import { ReactComponent as CheckBoxIcon } from "../../assets/icons/icon-checkbox-unchecked.svg";
import { ReactComponent as CheckBoxCheckedIcon } from "../../assets/icons/icon-checkbox-checked.svg";
import ReportHyperLink from "../../components/_report/cards/ReportHyperLink";
import { getReportById } from "../../config/services/reports";
import { useNavigate } from "react-router-dom";
import { set } from "lodash";
import ArrowRightOutlinedIcon from '@mui/icons-material/ArrowRightOutlined';
import ArrowLeftIcon from '@mui/icons-material/ArrowLeft';
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import { CaretRightOutlined, CaretDownOutlined } from '@ant-design/icons';

const API_URL = url.cubeApiUrl;
const DATASET_ID = "6532527d6728e60043861a0e";
const DATASET_NAME = "ZoneWiseEscReport";
const COLUMN_SORT_ORDER = {
  region: {
    title: "Region",
    style: {
      backgroundColor: "#d9e1f2",
    },
    isCollapsed: true,
  },
  territoryName: {
    title: "Territory",
    style: {
      backgroundColor: "#d9e1f2",
    },
    isCollapsed: true,
  },
  totalEmployees: {
    title: (
      <p>
        Active <br /> Employees
      </p>
    ),
    style: {
      backgroundColor: "#d9e1f2",
    },
    isCollapsed: true,
  },
  ACTIVEEMSCHOOLS: {
    title: "Transition Opportunity - Activated",
    children: {
      Schools: {
        title: "Schools",
        description: "Sum Total of All Clients for ESC, ESC+, LA and LIVE",
        linkedDashboardId: "653b5d54d445a40012f24cfa",
      },
      Impl_Forms: {
        title: "Impl forms",
        description: "Count of IF for all filled under ESC, ESC+, LA and LIVE",
      },
      ESC_Units: {
        title: "ESC Units",
        description: "Classroom Units signed under ESC, ESC+",
      },
      Students_Units: {
        title: "Student Units",
        description: "All Licenses sold under ESC, ESC+, LA, AC",
      },
      Teachers_Units: {
        title: "Teacher Units",
        description: "All Licenses sold under ESC, ESC+, TA",
      },
    },
    style: {
      backgroundColor: "#c6e0b4",
    },
    isCollapsed: true,
  },
  TRANSITIONOPPORTUNITYACTIVATED: {
    title: "Admin Panel Activated",
    children: {
      Schools: {
        title: "Schools",
        description: "Sum Total of All Clients for ESC+, LA",
        linkedDashboardId: "653e9e9d0cfffa0012520ed7",
      },
      Impl_Forms: {
        title: "Impl forms",
        description: "Count of IF for all filled under ESC+, LA",
      },
      ESC_Units: {
        title: "ESC Units",
        description: "Classroom Units signed under ESC+",
      },
      Students_Units: {
        title: "Student Units",
        description: "All Licenses sold under ESC+, LA, AC",
      },
      Teachers_Units: {
        title: "Teacher Units",
        description: "All Licenses sold under ESC+, TA",
      },
    },
    style: {
      backgroundColor: "#fdffb6",
    },
    isCollapsed: true,
  },

  ESCADMINPANELACTIVATED: {
    title: "ESC+ Admin Panel Activated",
    children: {
      Schools: {
        title: "Schools",
        description: "Sum Total of active Schools with Admin Panels under ESC+",
        linkedReportId: "653f3159182b0500120a4af5",
      },
      Impl_Forms: {
        title: "Impl forms",
        description: "Count of Activated IF filled under ESC+",
      },
      ESC_Units: {
        title: "ESC Units",
        description: "Total Activated Classrooms signed under ESC+",
      },
      Students_Units: {
        title: "Student Units",
        description: "Student Licenses Sold an Allocated under ESC+",
      },
      Teachers_Units: {
        title: "Teacher Units",
        description: "Teacher Licenses Sold and Allocated under ESC+",
      },
    },
    style: {
      backgroundColor: "#fce4d6",
    },
    isCollapsed: false,
  },
  EMSTSCHOOLS: {
    title: "EMST Schools",
    children: {
      Schools: {
        title: "Schools",
        // description: "Sum Total of active Schools with Admin Panels under ESC+",
        // linkedReportId: "653f3159182b0500120a4af5",
      },
      ESC_Units: {
        title: "ESC Units",
        // description: "Count of Activated IF filled under ESC+",
      },
      Students_Onboarded: {
        title: "Students Onboarded",
        // description: "Total Activated Classrooms signed under ESC+",
      },
    },
    style: {
      backgroundColor: "#C0FDFB",
    },
    isCollapsed: false,
  },
  onboarded: {
    title: "Onboarded",
    children: {
      Students_onboarded: {
        title: (
          <p>
            Students <br /> onboarded
          </p>
        ),
        description:
          " Total Students Onboarded on Activated Admin Panels with produt ESC+ ",
      },
      Teachers_unit: {
        title: "Teacher Units",
        description:
          " Total Teachers Onboarded on Activated Admin Panels with produt ESC+ ",
      },
    },
    style: {
      backgroundColor: "#ffff00",
    },
    isCollapsed: false,
    format: (value) => (!value || value === "null" ? "0" : value),
  },
  onboardedPercentage: {
    title: "Onboarded %",
    children: {
      Students_onboarded: {
        title: (
          <p>
            Students <br /> onboarded
          </p>
        ),
        description:
          " %age of Total Students Onboarded on Activated Admin Panels against total sold units with produt ESC+ ",
      },
      Teachers_unit: {
        title: "Teacher Units",
        description:
          " Total Teachers Onboarded on Activated Admin Panels against total sold units with produt ESC+",
      },
    },
    style: {
      backgroundColor: "#a9d08e",
    },
    isCollapsed: false,
    format: (value) => (!value || value === "null" ? "0%" : `${value}%`),
  },
  SCHOLARSHIPTESTASSIGNED: {
    title: "Scholarship Test Assigned",
    children: {
      Number_Of_Schools: {
        title: "Schools",
        // description: "Sum Total of active Schools with Admin Panels under ESC+",
      },
      Number_Of_Students: {
        title: "Students",
        // description: "Count of Activated IF filled under ESC+",
      },
    },
    style: {
      backgroundColor: "#A3C4BC",
    },
    isCollapsed: false,
  },
  SCHOLARSHIPTESTATTEMPTED: {
    title: "Scholarship Test Attempted",
    children: {
      Number_Of_Schools: {
        title: "Schools",
        // description: "Sum Total of active Schools with Admin Panels under ESC+",
      },
      Number_Of_Students: {
        title: "Students",
        // description: "Count of Activated IF filled under ESC+",
      },
    },
    style: {
      backgroundColor: "#A3C4BC",
    },
    isCollapsed: false,
  },
  SCHOLARSHIPTESTPENDING: {
    title: "Scholarship Test Pending",
    children: {
      Number_Of_Schools: {
        title: "Schools",
        // description: "Sum Total of active Schools with Admin Panels under ESC+",
      },
      Number_Of_Students: {
        title: "Students",
        // description: "Count of Activated IF filled under ESC+",
      },
    },
    style: {
      backgroundColor: "#A3C4BC",
    },
    isCollapsed: false,
  },
  ENROLLEDFORREVISIONBATCHES: {
    title: "Enrolled For Revision Batches",
    children: {
      Number_Of_Schools: {
        title: "Schools",
        // description: "Sum Total of active Schools with Admin Panels under ESC+",
      },
      Number_Of_Students: {
        title: "Students",
        // description: "Count of Activated IF filled under ESC+",
      },
    },
    style: {
      backgroundColor: "#A3C4BC",
    },
    isCollapsed: false,
  },
  ESCADMINPANELNOTACTIVATED: {
    title: "ESC+ Admin Panel Not Activated",
    children: {
      Schools: {
        title: "Schools",
        description:
          "Sum Total of active Schools without Admin Panels activated under ESC+",
        linkedReportId: "653f3163182b0500120a4b05",
      },
      Impl_Forms: {
        title: "Impl forms",
        description:
          "Count of IF filled without Admin Panels activated under ESC+",
      },
      ESC_Units: {
        title: "ESC Units",
        description:
          "Total Classrooms signed without Admin Panels activated under ESC+",
      },
      Students_Units: {
        title: "Student Units",
        description:
          "Student Licenses Sold an Allocated without Admin Panels activated under ESC+",
      },
      Teachers_Units: {
        title: "Teacher Units",
        description:
          "Teacher Licenses Sold and Allocated without Admin Panels activated under ESC+",
      },
    },
    style: {
      backgroundColor: "#fce4d6",
    },
    isCollapsed: false,
  },
  ACTIVATEDASLA: {
    title: "Activated as LA/LIVE",
    children: {
      Schools: {
        title: "Schools",
        description:
          "Sum Total of Active Schools with Admin Panels of Products LA, AC/Live",
        linkedReportId: "653e4e2f987252001392e123",
      },
      Impl_Forms: {
        title: "Impl forms",
        description:
          "Count of IF filled under LA, AC/LIVE whose Admin Panel is activated for LA, AC/Live",
      },
      ESC_Units: {
        title: "ESC Units",
        description: "ESC Units signed with schools who also signed LA/Live",
      },
      Students_Units: {
        title: "Student Units",
        description: "Licenses Sold and Allocated under LA, AC/Live",
      },
      // 'Teachers_Units': { title: 'Teacher Units', description: 'Teacher Units' }
      Teachers_Units: false,
    },
    style: {
      backgroundColor: "#ffe699",
    },
    isCollapsed: false,
  },
  ACTIVATEDASTA: {
    title: "Activated as TA",
    children: {
      Schools: {
        title: "Schools",
        description:
          "Sum Total of Active Schools with Admin Panels of Products TA, TLA",
        linkedReportId: "653e4e37987252001392e12d",
      },
      Impl_Forms: {
        title: "Impl forms",
        description:
          "Count of IF filled under TA whose Admin Panel is activated for TA, TLA",
      },
      ESC_Units: {
        title: "ESC Units",
        description:
          "ESC Units signed with schools who also signed TA/TLA or just TA, TLA",
      },
      // 'Students_Units': { title: 'Student Units', description: 'Student Units' },
      Students_Units: false,
      Teachers_Units: {
        title: "Teacher Units",
        description: "Licenses Sold and Allocated under TA, TLA",
      },
    },
    style: {
      backgroundColor: "#ffe699",
    },
    isCollapsed: false,
  },
  NOTACTIVATED: {
    title: "Not Activated",
    children: {
      Schools: {
        title: "Schools",
        description: "Active Schools with No Admin Panel",
      },
      Impl_Forms: {
        title: "Impl forms",
        description:
          "Count of Implementation Forms against active schools who don’t have Admin Panel",
      },
      ESC_Units: {
        title: "ESC Units",
        description:
          "Count of ESC's against active schools who don’t have Admin Panel",
      },
      Students_Units: {
        title: "Student Units",
        description: "Total Students yet to be activated (ESC' Units*40)",
      },
      Teachers_Units: {
        title: "Teacher Units",
        description: "Total teachers yet to be activated (ESC' Units*5)",
      },
    },
    style: {
      backgroundColor: "#d9e1f2",
    },
    // isCollapsed: true,
  },
};

const COLUMN_SORT_ORDER_KEYS = Object.keys(COLUMN_SORT_ORDER);

const useDashboardData = (onReportLinkClick = () => {}) => {
  const [dashboardState, setDashboardState] = useState({
    data: null,
    loading: false,
    error: null,
  });

  let cubejsApi;
  const CUBE_TOKEN = localStorage.getItem("cubeToken");
  if (CUBE_TOKEN) {
    cubejsApi = cubejs(CUBE_TOKEN, { apiUrl: `${API_URL}/cubejs-api/v1` });
  } else {
    cubejsApi = "";
  }

  const getTableFormatedData = (data) => {
    if (!data) return { column: [], rows: [] };
    const res = data.reduce(
      (acc, item, index) => {
        const arrayOfKeyValues = Object.entries(item);
        let row = {
          key: `row-data-${index}`,
        };
        arrayOfKeyValues.forEach(([key, value], arrIndex) => {
          const toUseKey = key.split(".").pop();
          let columnIndex = acc.column.findIndex((col) => col.key === toUseKey);
          let column = acc.column[columnIndex] ?? {};
          if (columnIndex === -1) {
            column = {
              title: COLUMN_SORT_ORDER[toUseKey]?.title ?? toUseKey,
              key: toUseKey,
              children: [],
              width: "150px",
              ellipsis: false,
              isCollapsed: false,
              fixed:
                toUseKey === "territoryName" || toUseKey === "region"
                  ? "left"
                  : null,
              onHeaderCell: () => {
                return {
                  style: {
                    backgroundColor:
                      COLUMN_SORT_ORDER[toUseKey]?.style?.backgroundColor ??
                      "#fff",
                    fontWeight: "bold",
                    fontSize: "14px",
                    color: "#000",
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis",
                    overflow: "hidden",
                  },
                };
              },
              onCell: () => {
                return {
                  style: {
                    backgroundColor:
                      COLUMN_SORT_ORDER[toUseKey]?.style?.backgroundColor ??
                      "#fff",
                    fontSize: "14px",
                    color: "#000",
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis",
                    overflow: "hidden",
                  },
                };
              },
              render: (text, record, index) => {
                if (toUseKey === "region" || toUseKey === "territoryName") {
                  if (record.lastrow)
                    return {
                      children:
                        toUseKey === "region" ? (
                          <span style={{ fontWeight: "bold" }}>Total:</span>
                        ) : null,
                      props: {
                        rowSpan: 3,
                      },
                    };
                  if (toUseKey === "region") {
                    return {
                      children:
                        acc.rows[index - 1]?.region === text ? null : (
                          <span>{text}</span>
                        ),
                    };
                  }
                }
                return {
                  children:
                    (COLUMN_SORT_ORDER[toUseKey]?.linkedReportId ||
                      COLUMN_SORT_ORDER[toUseKey]?.linkedDashboardId) &&
                    !record.lastrow ? (
                      <a
                        className="table-report-link"
                        style={{
                          cursor: "pointer",
                          textDecoration: "underline",
                          width: "100%",
                          height: "100%",
                          display: "block",
                        }}
                        onClick={() =>
                          onReportLinkClick({
                            reportId:
                              COLUMN_SORT_ORDER[toUseKey]?.linkedReportId,
                            dashboardId:
                              COLUMN_SORT_ORDER[toUseKey]?.linkedDashboardId,
                            region: record.region,
                            territoryName: record.territoryName,
                          })
                        }
                      >
                        {text}
                      </a>
                    ) : (
                      <span>{text}</span>
                    ),
                };
              },
            };
            if (
              typeof value === "string" &&
              parseToJson(value) &&
              parseToJson(value) !== value
            ) {
              const subHeadKeyValueArr = Object.entries(JSON.parse(value));
              subHeadKeyValueArr.forEach(([subKey, subValue]) => {
                if (COLUMN_SORT_ORDER[toUseKey]?.children[subKey] === false)
                  return;
                column.children.push({
                  title: (
                    <Tooltip
                      title={
                        COLUMN_SORT_ORDER[toUseKey]?.children[subKey]
                          ?.description
                      }
                    >
                      {COLUMN_SORT_ORDER[toUseKey]?.children[subKey]?.title
                        ? COLUMN_SORT_ORDER[toUseKey]?.children[subKey]?.title
                        : subKey.split("_").join(" ")}
                    </Tooltip>
                  ),
                  key: subKey,
                  // dataIndex: subKey,
                  dataIndex: `${toUseKey}-${subKey}`,
                  width: "150px",
                  ellipsis: false,
                  onHeaderCell: () => {
                    return {
                      style: {
                        backgroundColor:
                          COLUMN_SORT_ORDER[toUseKey]?.style?.backgroundColor ??
                          "#fff",
                        fontWeight: "bold",
                        fontSize: "14px",
                        color: "#000",
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis",
                        overflow: "hidden",
                      },
                    };
                  },
                  onCell: () => {
                    return {
                      style: {
                        backgroundColor:
                          COLUMN_SORT_ORDER[toUseKey]?.style?.backgroundColor ??
                          "#fff",
                        fontSize: "14px",
                        color: "#000",
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis",
                        overflow: "hidden",
                      },
                    };
                  },
                  render: (text, record, index) => {
                    return {
                      children:
                        (COLUMN_SORT_ORDER[toUseKey]?.children?.[subKey]
                          ?.linkedReportId ||
                          COLUMN_SORT_ORDER[toUseKey]?.children?.[subKey]
                            ?.linkedDashboardId) &&
                        !record.lastrow ? (
                          <a
                            className="table-report-link"
                            style={{
                              cursor: "pointer",
                              textDecoration: "underline",
                              width: "100%",
                              height: "100%",
                              display: "block",
                            }}
                            onClick={() =>
                              onReportLinkClick({
                                reportId:
                                  COLUMN_SORT_ORDER[toUseKey]?.children?.[
                                    subKey
                                  ]?.linkedReportId,
                                dashboardId:
                                  COLUMN_SORT_ORDER[toUseKey]?.children?.[
                                    subKey
                                  ]?.linkedDashboardId,
                                region: record.region,
                                territoryName: record.territoryName,
                              })
                            }
                          >
                            {text}
                          </a>
                        ) : (
                          <span>{text}</span>
                        ),
                    };
                  },
                });
                row[`${toUseKey}-${subKey}`] = COLUMN_SORT_ORDER[toUseKey]?.format
                  ? COLUMN_SORT_ORDER[toUseKey]?.format(subValue)
                  : subValue;
              });
            } else {
              column.dataIndex = toUseKey;
              row[toUseKey] = COLUMN_SORT_ORDER[toUseKey]?.format
                ? COLUMN_SORT_ORDER[toUseKey]?.format(value)
                : value;
            }
            columnIndex = acc.column.length;
          } else {
            if (
              typeof value === "string" &&
              parseToJson(value) &&
              parseToJson(value) !== value
            ) {
              const subHeadKeyValueArr = Object.entries(JSON.parse(value));
              subHeadKeyValueArr.forEach(([subKey, subValue]) => {
                row[`${toUseKey}-${subKey}`] = COLUMN_SORT_ORDER[toUseKey]?.format
                  ? COLUMN_SORT_ORDER[toUseKey]?.format(subValue)
                  : subValue;
              });
            } else {
              row[toUseKey] = COLUMN_SORT_ORDER[toUseKey]?.format
                ? COLUMN_SORT_ORDER[toUseKey]?.format(value)
                : value;
            }
          }
          acc.column[columnIndex] = column;
        });
        acc.rows.push(row);
        return acc;
      },
      { column: [], rows: [] }
    );

    res.column = res.column.sort((a, b) => {
      // push the non found elements at last while sorting
      if (COLUMN_SORT_ORDER_KEYS.indexOf(a.key) === -1) {
        return 1;
      }
      if (COLUMN_SORT_ORDER_KEYS.indexOf(b.key) === -1) {
        return -1;
      }
      return (
        COLUMN_SORT_ORDER_KEYS.indexOf(a.key) -
        COLUMN_SORT_ORDER_KEYS.indexOf(b.key)
      );
    });

    //sort the rows based on the region
    res.rows = res.rows.sort((a, b) => {
      if (a.region > b.region) {
        return 1;
      }
      if (a.region < b.region) {
        return -1;
      }
      return 0;
    });

    // last row
    // res.rows.push({
    //     lastrow: true,
    //     key: `last-row`,
    //     ...getSumOfRows(res.rows)
    // });

    return res;
  };

  useEffect(() => {
    const getData = async () => {
      if (!dashboardState.data && !dashboardState.error) {
        setDashboardState({ data: null, loading: true, error: null });
        try {
          //get measures
          const measuresData = await getMeasuresList({ dataSetId: DATASET_ID });
          const { measures, dimensions } = await measuresData?.result?.reduce(
            (acc, ele) => {
              if (ele?.dataSetType === "MEASURE") {
                acc.measures.push(`${DATASET_NAME}.${ele?.name}`);
              } else {
                acc.dimensions.push(`${DATASET_NAME}.${ele?.name}`);
              }
              return acc;
            },
            { measures: [], dimensions: [] }
          );
          const cubeData = await cubejsApi.load({
            // measures,
            dimensions,
            renewQuery: true,
            limit: 50,
          });
          const tableData = await cubeData?.rawData();
          const tableFormatData = await getTableFormatedData(tableData);
          await setDashboardState({
            data: tableFormatData,
            loading: false,
            error: null,
          });
        } catch (error) {
          console.log("Error occured", error);
          setDashboardState({ data: null, loading: false, error: error });
        }
      }
    };
    getData();
  }, []);

  return dashboardState;
};

const parseToJson = (str) => {
  try {
    return JSON.parse(str);
  } catch (error) {
    return null;
  }
};


function getSumOfRows(rows) {
  const rowLength =rows.length
  const sum = rows.reduce((acc, row) => {
    Object.keys(row).forEach((key) => {
      if (typeof row[key] !== "number") {
        if (row[key].endsWith("%")) {
            row[key] = parseInt(row[key].slice(0, -1), 10);
          }
        else return
      }

      if (acc[key]) {
        acc[key] += row[key];
      } else {
        acc[key] = row[key];
      }
    });
    
    return acc;
}, {});
  sum['onboardedPercentage-Students_onboarded'] = (sum['onboardedPercentage-Students_onboarded'] / rowLength).toFixed(1) + '%';
  sum['onboardedPercentage-teachers_unit'] = (sum['onboardedPercentage-teachers_unit'] / rowLength).toFixed(1) + '%';

  return sum;
}

const Filter = ({ filter, setFilter, data }) => {
  const [filterSearchText, setFilterSearchText] = useState({});
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const menuOf = anchorEl?.id?.split("-")[0];
  const filterOptions = useMemo(() => {
    const options = {
      region: new Set(),
      territoryName: new Set(),
      filterSearchText: {},
    };
    if (!data) return options;
    if (options.filterSearchText[menuOf] !== filterSearchText[menuOf]) {
      options.filterSearchText[menuOf] = filterSearchText[menuOf];
    }
    data.rows.forEach((row) => {
      if (row.region) {
        if (!options.filterSearchText[menuOf]?.length)
          options.region.add(row.region);
        if (
          row.region
            .toLowerCase()
            .includes(options.filterSearchText[menuOf]?.toLowerCase())
        )
          options.region.add(row.region);
      }
      if (row.territoryName) {
        if (!options.filterSearchText[menuOf]?.length)
          options.territoryName.add(row.territoryName);
        if (
          row.territoryName
            .toLowerCase()
            .includes(options.filterSearchText[menuOf]?.toLowerCase())
        )
          options.territoryName.add(row.territoryName);
      }
    });
    return options;
  }, [data, filterSearchText]);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
    setFilterSearchText((prevFilterSearchText) => {
      return {
        ...prevFilterSearchText,
        [menuOf]: "",
      };
    });
  };

  const onSearchChange = (e) => {
    const value = e.target.value;
    setFilterSearchText((prevFilterSearchText) => {
      return {
        ...prevFilterSearchText,
        [menuOf]: value,
      };
    });
  };
  return (
    <Box
      sx={{
        display: "flex",
      }}
    >
      <Box
        sx={{
          display: "flex",
          mb: 2,
        }}
      >
        <Button
          id="region-filter-button"
          aria-controls={open ? "basic-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={open ? "true" : undefined}
          onClick={handleClick}
          sx={{
            backgroundColor: "#fff",
            borderRadius: "4px !important",
            border: "1px solid",
            borderColor: !filter["region"]?.length ? "#6f6f6f" : "#202124",
            color: "#202124 !important",
            width: "150px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mr: 2,
          }}
        >
          <Typography
            variant="p"
            sx={{ color: !filter["region"]?.length ? "#6f6f6f" : "#202124" }}
          >
            {!filter["region"]?.length
              ? "Region"
              : `${
                  filter["region"]?.length === 1
                    ? filter["region"][0]
                    : `Region(${filter["region"]?.length})`
                }`}{" "}
          </Typography>
          {filter["region"]?.length ? (
            <AngleDownBlackIcon />
          ) : (
            <AngleDownIcon />
          )}
        </Button>
        <Button
          id="territoryName-filter-button"
          aria-controls={open ? "basic-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={open ? "true" : undefined}
          onClick={handleClick}
          sx={{
            backgroundColor: "#fff",
            borderRadius: "4px !important",
            border: "1px solid",
            borderColor: !filter["territoryName"]?.length
              ? "#6f6f6f"
              : "#202124",
            color: "#202124 !important",
            width: "150px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography
            variant="p"
            sx={{
              color: !filter["territoryName"]?.length ? "#6f6f6f" : "#202124",
            }}
          >
            {!filter["territoryName"]?.length
              ? "Territory"
              : `${
                  filter["territoryName"]?.length === 1
                    ? filter["territoryName"][0]
                    : `Territory(${filter["territoryName"]?.length})`
                }`}
          </Typography>
          {filter["territoryName"]?.length ? (
            <AngleDownBlackIcon />
          ) : (
            <AngleDownIcon />
          )}
        </Button>
      </Box>
      <Menu
        id="filter-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        {/* seach */}
        <Box
          sx={{
            padding: "20px 20px 20px 20px",
          }}
        >
          <TextField
            type="search"
            size="medium"
            name={menuOf}
            placeholder="Search..."
            className="cm_rprt_setting_content form_input_outline dasboard-filters-view-dropdown-search"
            onChange={onSearchChange}
            InputProps={{
              endAdornment: (
                <InputAdornment position="start">
                  <InputSearchIcon className="input_search_icon" />
                </InputAdornment>
              ),
            }}
          />
        </Box>
        <Box
          sx={{ width: "100%", height: "1px", backgroundColor: "#dedede" }}
        ></Box>
        {/* filter options */}
        <Box
          sx={
            {
              // padding: '20px 20px 20px 20px',
            }
          }
        >
          {filterOptions?.[menuOf]?.size > 0 ? (
            <Box
              sx={{
                minHeight: "200px",
                overflow: "auto",
              }}
            >
              <AutoSizer>
                {({ height, width }) => {
                  return (
                    <List
                      className="List"
                      height={height}
                      itemCount={filterOptions[menuOf]?.size ?? 20}
                      itemSize={35}
                      width={width - 4}
                      itemData={Array.from(filterOptions[menuOf])}
                    >
                      {({ index, style, data }) => {
                        const option = [...filterOptions[menuOf]][index];
                        return (
                          <Box
                            sx={{
                              ...style,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                              padding: "0px 10px",
                              cursor: "pointer",
                              "&:hover": {
                                backgroundColor: "#dedede",
                              },
                            }}
                            onClick={() => {
                              if (filter[menuOf].indexOf(option) === -1) {
                                setFilter((prevFilter) => {
                                  return {
                                    ...prevFilter,
                                    [menuOf]: [...prevFilter[menuOf], option],
                                  };
                                });
                              } else {
                                setFilter((prevFilter) => {
                                  return {
                                    ...prevFilter,
                                    [menuOf]: prevFilter[menuOf].filter(
                                      (ele) => ele !== option
                                    ),
                                  };
                                });
                              }
                            }}
                          >
                            <FormControlLabel
                              className="filters-view-checkbox"
                              control={
                                <Checkbox
                                  className="form_checkbox"
                                  icon={
                                    <span sx={{ width: "5px", height: "5px" }}>
                                      <CheckBoxIcon />
                                    </span>
                                  }
                                  checkedIcon={<CheckBoxCheckedIcon />}
                                  checked={filter[menuOf].includes(option)}
                                />
                              }
                              label={data[index]}
                            />
                          </Box>
                        );
                      }}
                    </List>
                  );
                }}
              </AutoSizer>
            </Box>
          ) : null}
        </Box>
      </Menu>
    </Box>
  );
};

export default function CrmDashboard() {
  const [linkedReportState, setLinkedReportState] = useState(null);
  const isLinkedReportStateModalOpen = Boolean(linkedReportState);
  const { data, loading, error } = useDashboardData(onReportLinkClick);
  const [expandedRowKeys, setExpandedRowKeys] = useState("");
  const [collapsed, setCollapsed] = useState(false);
  const [filter, setFilter] = useState({
    region: [],
    territoryName: [],
  });
  const navigate = useNavigate();
  const containerRef = useRef(null);
  const [columnData, setColumnData] = useState([]);

  const collapseActionObj = {
    title: <KeyboardDoubleArrowLeftIcon onClick={() => primaryTable('collapse')} sx={{backgroundColor: '#60d394', border: 'none', cursor: 'pointer'}}/>,
    key: "collapse",
    width: "50px",
    onHeaderCell: () => {
      return {
        style: {
          backgroundColor: '#d9e1f2',
          fontWeight: "bold",
          fontSize: "14px",
          color: "#000",
          whiteSpace: "nowrap",
          overflow: "hidden",
        },
      };
    },
    onCell: () => {
      return {
        style: {
          backgroundColor: '#d9e1f2',
          fontSize: "14px",
          color: "#000",
          whiteSpace: "nowrap",
          overflow: "hidden", 
        },
      };
    },
  };
  const expandActionObj = {
    title: <KeyboardDoubleArrowRightIcon onClick={() => primaryTable('expand')} sx={{background: '#ee6352', border: 'none', cursor: 'pointer' }}/>,
    key: "expand",
    width: "50px",
    onHeaderCell: () => {
      return {
        style: {
          backgroundColor: '#d9e1f2',
          fontWeight: "bold",
          fontSize: "14px",
          color: "#000",
          whiteSpace: "nowrap",
          overflow: "hidden",
        },
      };
    },
    onCell: () => {
      return {
        style: {
          backgroundColor: '#d9e1f2',
          fontSize: "14px",
          color: "#000",
          whiteSpace: "nowrap",
          overflow: "hidden",
        },
      };
    },
  };

  const tableData = useMemo(() => {
    if (!data) return [];
    let _rows = [...data.rows];
    if (filter.region.length || filter.territoryName.length) {
      _rows = _rows.filter((row) => {
        if (filter.region.length && filter.region.indexOf(row.region) === -1) {
          return false;
        }
        if (
          filter.territoryName.length &&
          filter.territoryName.indexOf(row.territoryName) === -1
        ) {
          return false;
        }
        return true;
      });
    }
    // if (!filter.region.length && !filter.territoryName.length) return data.rows;
    _rows.push({
      lastrow: true,
      key: `last-row`,
      ...getSumOfRows(_rows),
    });
    return _rows;
  }, [data, filter]);

  function onReportLinkClick({ reportId, dashboardId, region, territoryName }) {
    try {
      if (!reportId && !dashboardId) return;
      if (dashboardId) {
        let filterObj = [{territoryName: territoryName} , { region: region }];
        let url = new URL(
          `https://test-report.extramarks.com/embedDashboard/${dashboardId}`
        );
        //url = new URL(`http://localhost:3000/embedDashboard/${reportId}`)
        url.searchParams.append(
          "filterParams",
          encodeURIComponent(JSON.stringify(filterObj))
        );
        window.open(url, "_blank");
        return;
      }
      getReportById({ reportId }).then(async (res) => {
        if (res?.result) {
          const report = res?.result;
          if (report) {
            let dataSetName = null;
            if (report?.dimensions.length) {
              dataSetName = report?.dimensions[0]?.fieldName.split(".")[0];
            }
            if (!dataSetName && report?.measures.length) {
              dataSetName = report?.measures[0]?.fieldName.split(".")[0];
            }
            if (!dataSetName && report?.timeDimensions.length) {
              dataSetName = report.timeDimensions[0].dimension?.split(".")[0];
            }
            // TODO: check filter same filter exist

            if (territoryName) {
              report.reportFilters = [
                ...report.reportFilters,
                {
                  member: `${dataSetName}.region`,
                  operator: "equals",
                  values: [region],
                },
                {
                  member: `${dataSetName}.territoryName`,
                  operator: "equals",
                  values: [territoryName],
                },
              ];
            } else {
              report.reportFilters = [
                ...report.reportFilters,
                {
                  member: `${dataSetName}.region`,
                  operator: "equals",
                  values: [region],
                },
              ];
            }
            setLinkedReportState(report);
          }
        }
      });
    } catch (error) {
      console.log("linked report data error : ", error);
    }
  }

  const groupedObjects = tableData.reduce((acc, current) => {
    if (!acc[current.region]) {
      acc[current.region] = [];
    }
    acc[current.region].push(current);
    return acc;
  }, {});

  const expandableRows = tableData.reduce((arrayObj, current) => {
    if (!arrayObj.some((item) => item.region === current.region)) {
      if (!current.lastrow) {
        arrayObj.push({
          region: current.region,
          key: current.key,
          ...getSumOfRows(groupedObjects[current.region]),
        });
      } else {
        arrayObj.push(current);
      }
    }
    return arrayObj;
  }, []);


  const handleExpandedRowsChange = (newExpandedRows) => {
    const lastEntry = newExpandedRows.pop();
    setExpandedRowKeys([lastEntry]);
  };

  const expandIconNull = () => null

  const expandedRowRender = () => {
    const key = expandedRowKeys[0];
    const rowToExpand = tableData?.find((row) => row.key === key);
    const subRowData = tableData?.filter(
      (row) => row?.region === rowToExpand?.region
    );
    const subColumnData = data.column?.filter(
      (column) => column.key !== "region"
    );

    let updatedSubColumnData 
    if(collapsed){
        updatedSubColumnData=handleExpand(subColumnData)
    }
    else{
        updatedSubColumnData=handleCollapse(subColumnData)
    }
    
    const expandedRowRender = () => null
    return (
      <div style={{borderTop: '3px solid #8d99ae',  borderBottom: '3px solid #8d99ae'}}>
        <Table
          columns={updatedSubColumnData}
          dataSource={subRowData}
          pagination={false}
          showHeader={false}
          expandable={ {expandedRowRender,
             expandIcon: expandIconNull 
            }}
          // scroll={{ y: `calc(100vh - 300px)`, x: "max-content" }}
        />
      </div>
    );
  };

  const handleScroll = (e) => {
    if (containerRef.current) {
      containerRef.current.scrollLeft = e.target.scrollLeft;
    }
  };

  const primaryTable = (type) => {
      let columnDataObj = data?.column.filter(
          (obj) => obj.key !== "territoryName"
      );
      let updatedColumnObj
      if(type === 'expand'){
          updatedColumnObj = handleExpand(columnDataObj)
          setColumnData(updatedColumnObj);
          setCollapsed(true);
      }
      else if(type === 'collapse'){
          updatedColumnObj = handleCollapse(columnDataObj)
          setColumnData(updatedColumnObj);
          setCollapsed(false);
      }
  }

  const handleCollapse = (columnDataObj) => {
        let state = false;
        columnDataObj = columnDataObj?.filter((obj) => {
            if (obj.key === "TRANSITIONOPPORTUNITYACTIVATED") {
            state = true;
            return obj
            }
            else if(obj.key === "NOTACTIVATED"){
                state = false;
            }
            if (state) return;
            else return obj;
        });
        columnDataObj?.splice(columnDataObj.length-1, 0, expandActionObj);
        return columnDataObj;
    };

  const handleExpand = (columnDataObj) => {
        columnDataObj?.splice(columnDataObj.length-1, 0, collapseActionObj);
        return columnDataObj;
    }


  useEffect(async () => {
    if (data) {
        primaryTable('collapse')
    }
  }, [data]);

  const customExpandIcon = (props) => {
    if(props.expandable) {
      if (props.expanded) {
        return <CaretDownOutlined className='dropdown' style={{ fontSize: '16px', color: 'green'}}  onClick={(e) => props.onExpand(props.record, e)} />;
      } else {
        return <CaretRightOutlined className='dropdown' style={{ fontSize: '16px', color: 'red'}}   onClick={(e) => props.onExpand(props.record, e)}/>;
      }
    }
    else return null
  }

  return (
    <Box
      sx={{
        display: "flex",
        minHeight: "100%",
        overflow: "hidden",
        padding: "0px 20px",
      }}
    >
      <Box
        sx={{
          flexGrow: 1,
          overflow: "auto",
          minHeight: "100%",
        }}
      >
        <Box className="embed-reports">
          <Grid container mb={2}>
            <Grid
              className="er-heading-content"
              item
              alignItems="start"
              justifyContent="flex-start"
              sm={12}
              md={12}
              lg={12}
            >
              <Box className="er-content mt-0">
                <Typography
                  className="er-heading-title-sub"
                  variant="h4"
                  noWrap
                >
                  {handleLanguageChange("CRM Dashboard")}
                </Typography>
              </Box>
            </Grid>
            <Grid
              container
              item
              className="re-sr-filter-grid crm-dashboard"
              alignItems="start"
              justifyContent="flex-start"
              spacing={2}
              sm={12}
              md={12}
              lg={12}
              my={2}
            >
              {loading ? <Typography variant="p">Loading...</Typography> : null}
              {!loading && data ? (
                <div ref={containerRef} onScroll={handleScroll} className="expandableTable">
                  <Filter filter={filter} setFilter={setFilter} data={data} />
                  <Table
                    columns={columnData}
                    dataSource={expandableRows}
                    pagination={false}
                    loading={loading}
                    scroll={{ y: `calc(100vh - 300px)`, x: "100%" }}
                    expandable={{
                      expandedRowRender,
                      rowExpandable: (row) => row.key !== "last-row",
                      onExpandedRowsChange: handleExpandedRowsChange,
                      expandedRowKeys: expandedRowKeys,
                      expandIcon: customExpandIcon,
                    }}
                  />
                </div>
              ) : null}
            </Grid>
          </Grid>
          {/* linked report */}
          <ReportHyperLink
            hyperlinkModal={isLinkedReportStateModalOpen}
            closeHyperlinkModal={() => setLinkedReportState(null)}
            hyperlinkType={"int"}
            chartType={"table"}
            hyperlinkReportData={linkedReportState}
          />
        </Box>
      </Box>
    </Box>
  );
}
